var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon16PxOfficeWorkerOutline(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.49109 5.88464C6.42569 5.88464 7.18334 5.12696 7.18334 4.19232C7.18334 3.25768 6.42569 2.5 5.49109 2.5C4.55648 2.5 3.79883 3.25768 3.79883 4.19232C3.79883 5.12696 4.55648 5.88464 5.49109 5.88464Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.91764 10.9822L6.60294 13.5H4.38846L3.9654 10.1153H2.5293V8.84608C2.5293 8.06063 2.84131 7.30734 3.39668 6.75195C3.95206 6.19654 4.70532 5.88452 5.49075 5.88452C6.27617 5.88452 7.02943 6.19654 7.58481 6.75195C8.01198 7.17913 8.29517 7.72339 8.40316 8.30931",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.25586 10.5135C8.25586 10.1011 8.59012 9.76685 9.00245 9.76685H12.7354C13.1477 9.76685 13.482 10.1011 13.482 10.5135V12.7533C13.482 13.1657 13.1477 13.4999 12.7354 13.4999H9.00245C8.59012 13.4999 8.25586 13.1657 8.25586 12.7533V10.5135Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.84766 9.76682V9.21603C9.84766 8.74871 10.2265 8.36987 10.6938 8.36987H11.0429C11.5101 8.36987 11.889 8.74871 11.889 9.21603V9.76682",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon16PxOfficeWorkerOutline);
export default __webpack_public_path__ + "static/media/icon_16px_office-worker_outline.c7435d85d61414ee406acff72861c316.svg";
export { ForwardRef as ReactComponent };